/** Wide Capture pairs its local write surface with the live Horizon reading. */
import { CaptureView } from "./capture_view";
import { HorizonView } from "@/features/horizon/horizon_view";
import { useWide } from "@/hooks/use_wide";

export function CaptureLayout(): React.JSX.Element {
  const wide = useWide();
  // One tree in both layouts. CaptureView keeps its place, so crossing the
  // breakpoint — a tablet turning sideways — does not remount it and lose the
  // amount being typed or an open Undo. Narrow, the wrappers draw no box.
  return (
    <div className={wide ? "wide-capture" : "contents"}>
      <div className={wide ? "min-w-0 border-r border-line" : "contents"}><CaptureView /></div>
      {wide ? <div className="min-w-0"><HorizonView periodEndMoments={false} /></div> : null}
    </div>
  );
}
